module.exports = __webpack_public_path__ + "img/inbox-receives-mob.5f79e74b.webp";